/* ==========================================================================
   Homellence – D1 (Runde 34): die Erinnerung im Browsertab

   Wer in einen anderen Tab wechselt, findet nach einer Weile einen
   freundlichen Hinweis im Titel. **Einmal**, nicht blinkend.

   ## Was hier vorher stand

   Ein Dawn-Altskript, fest im Layout, das den Titel **im Sekundentakt**
   zwischen dem echten Titel und „✨ Come Back!" hin- und herschaltete.
   Vier Dinge daran waren falsch, und jedes einzelne ist hier anders gelöst:

   1. Es hing an `blur`. Das feuert auch, wenn jemand nur in ein anderes
      Programm klickt, während unser Tab weiter sichtbar ist – dann blinkt
      ein Titel, den niemand liest. Hier entscheidet `visibilitychange`
      zusammen mit `document.hidden`: Nur dann ist der Tab wirklich weg.
   2. Es schaltete im `setInterval`. Hier wird **einmal** gesetzt. Es gibt
      in dieser Datei keinen `setInterval`.
   3. Es kam ohne Verzug. Wer eine Sekunde wegklickt, bekam sofort eine
      Erinnerung; das wirkt klammernd. Hier sind es vier Sekunden, und wer
      vorher zurückkommt, merkt nie etwas davon.
   4. Der Text war fest und englisch, in einem Laden, der in 31 Sprachen
      läuft. Hier kommt er aus `hl.tab.away` bzw. `hl.tab.away_cart`, vom
      Layout in `data`-Attribute geschrieben – ein externes Skript kann
      Liquid nicht selbst übersetzen.

   ## Der Warenkorbstand

   Der Text richtet sich danach, ob etwas im Warenkorb liegt. Gelesen wird
   das aus der Zahl, die ohnehin an der Titelleiste steht
   (`[data-hl-cart-count]`) – **keine zusätzliche Anfrage an `/cart.js`**
   für eine Tab-Beschriftung. Die Zahl wird bei jeder Warenkorbänderung von
   `hl-ui.js` mitgeführt, ist also aktuell.

   Lässt sie sich nicht sicher lesen – Element fehlt, `hidden`, kein
   Zahlenwert –, gilt der leere Fall. Der ist nie falsch: „Bis gleich"
   stimmt auch für jemanden, der etwas im Warenkorb hat.

   ## Der ursprüngliche Titel

   Gemerkt wird er **beim Wegwechseln**, nicht beim Laden. Heute ändert
   keine Seite ihren Titel nachträglich; wenn das einmal jemand einbaut,
   stellt dieses Skript trotzdem das Richtige wieder her.

   ## Nicht im Theme-Editor

   `Shopify.designMode` ist dort wahr. Sonst schriebe das Skript Kristin
   beim Arbeiten in die Vorschau.
   ========================================================================== */
(function () {
  'use strict';

  /* Vier Sekunden: lang genug, dass ein kurzer Blick woandershin nichts
     auslöst, kurz genug, dass der Hinweis noch zum Besuch gehört. */
  var VERZUG = 4000;

  if (window.Shopify && window.Shopify.designMode) return;

  var quelle = document.querySelector('[data-hl-tab-reminder]');
  if (!quelle) return;

  var zeitgeber = null;

  /* Nicht null, solange die Erinnerung im Titel steht – und dann genau der
     Titel, der vorher dastand. Damit ist zugleich beantwortet, ob es etwas
     zurückzustellen gibt. */
  var urspruenglich = null;

  function warenkorbGefuellt() {
    var zaehler = document.querySelector('[data-hl-cart-count]');
    if (!zaehler) return false;
    if (zaehler.hasAttribute('hidden')) return false;
    var zahl = parseInt((zaehler.textContent || '').replace(/[^0-9]/g, ''), 10);
    return isFinite(zahl) && zahl > 0;
  }

  function beschriftung() {
    var wert = warenkorbGefuellt() ? quelle.getAttribute('data-away-cart') : quelle.getAttribute('data-away');
    return wert ? wert.trim() : '';
  }

  function abbrechen() {
    if (zeitgeber === null) return;
    window.clearTimeout(zeitgeber);
    zeitgeber = null;
  }

  function verbergen() {
    abbrechen();

    /* Steht die Erinnerung schon, bleibt sie stehen: Ein zweites `hidden`
       ohne zwischenzeitliches `visible` ist kein neuer Weggang. */
    if (urspruenglich !== null) return;

    var vorher = document.title;

    zeitgeber = window.setTimeout(function () {
      zeitgeber = null;
      var neu = beschriftung();
      if (!neu || neu === vorher) return;
      urspruenglich = vorher;
      document.title = neu;
    }, VERZUG);
  }

  function zeigen() {
    abbrechen();
    if (urspruenglich === null) return;
    document.title = urspruenglich;
    urspruenglich = null;
  }

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) verbergen();
    else zeigen();
  });
})();
